//@ts-nocheck
import "./style/taskdetail.scss";
import "./style/taskDetailsTemplates.scss";
import React from "react";
import "./style/grid.scss";
import TaskDetailsSubnavbar from "./navigation/Subnavbar.component";
import AsyncTaskActionExecutorTask from "./AsyncTaskActionExecutor.component";
import {
    CONFIRMATION, DETAILS_VIEW_TYPE, DOCUMENT_OVERVIEW_STATUS, LOADING_STATUS,
    WORKFLOW_DETAILS, DOCUMENT_DETAILS, DOCUMENT_PREVIEW, COMMENTS, EDITOR, ACCOUNTING_GRID,
    PANELS_BY_DOCTYPE_AND_INTEGRATION, DOCUMENT_TYPE, TASK_ACTIONS, DETAILS_STATUS, DOCUMENT_PREVIEW_STATUS,
    MODAL_ACTIONS,
} from "utils/constants";
import {useModalContext} from "components/modals/ModalContext";
import DocumentData from "./panels/DocumentData.component";
import WorkflowDetailsPanel from "./panels/workflowdetails/WorkflowDetailsPanel.component";
import NewWorkflowDetailsPanel from "./panels/newworkflowdetails/WorkflowDetailsPanel.component";
import AttachmentsPanel from "./panels/attachments/AttachmentsPanel.component";
import {connect} from "react-redux";
import {approveMultipleShortcutKey, loadTasks} from "../mytasks/myTasks.action";
import {changeTryToLoopTasksFlag} from "../mytasks/action/taskAction.action";
import translate from "../translations/translations.wrapper.jsx";
import {canDo, keyPressHandler} from "utils/keyPressHandler.function";
import * as reduxSelectors from "../store/application.reducers";
import DocumentEditorPanel from "./panels/editor/DocumentEditorPanel.component";
import AccountingGridPanel from "./panels/editor/AccountingGridPanel.component";
import MouseDown from "./icons/mouse-down.svg";
import {eventBus} from "../pagelayout/EventBus";
import {snowplowTrackEvent} from "utils/snowplow";
import "./style/task_details.scss";
import {ResizableBox} from "react-resizable";
import "react-resizable/css/styles.css";
import {Tooltip} from "components/tooltip/Tooltip";
import {SaveDiscardMessage} from "utils/confirmMoreMessages";
import {
    documentPreviewTitleChanged,
    documentPreviewStatusChanged,
    editorTitleChanged,
    editorReattach,
    taskDetailsClosing, selectedDocumentChanged,
} from "components/taskdetails-remake/taskDetails.action.js";
import {TaskSidebar} from "components/taskdetails-remake/navigation/TaskSidebar.component";
import DraftAndCommentsComponent
    from "components/taskdetails-remake/panels/draftcomments/DraftAndComments.component";
import
    DocumentPreviewWindow
    from "components/taskdetails-remake/panels/attachments/detached/DocumentPreviewWindow.component";
import
    DocumentEditorWindow
    from "components/taskdetails-remake/panels/editor/detached/DocumentEditorWindow.component";
import PropTypes from "prop-types";
import { SHARED_TOOLTIP_ID } from "components/tooltip/AppTooltip.component";
import { PanelErrorBoundary } from "components/errorpage/PanelErrorBoundary";
import {launchDarkly} from "utils/launchDarkly";

const LEFT_SIDE_MIN_WIDTH = 650;
const MIN_SCREEN_WIDTH_FOR_RESIZE = 1300;
const SPACE_BETWEEN_PANELS = 16;
export const NEW_WORKFLOW_DETAILS_FLAG = 'fe-use-new-taskdetails-workflow';

const HandledTaskTrigger = ({ closeCallback }) => {
    const { toggleModal } = useModalContext() || {};
    const closeCallbackRef = React.useRef(closeCallback);
    closeCallbackRef.current = closeCallback;

    React.useEffect(() => {
        toggleModal?.(MODAL_ACTIONS.HANDLED_TASK, { closeCallback: () => closeCallbackRef.current?.() });
    }, [toggleModal]);

    return null;
};

const NavigationConfirmTrigger = ({
    translate,
    iframeHasUnsavedChanges,
    enableSaveDiscard,
    remain,
    saveChanges,
    discardChanges,
}) => {
    const { toggleModal } = useModalContext() || {};
    const callbacksRef = React.useRef({ remain, saveChanges, discardChanges });
    callbacksRef.current = { remain, saveChanges, discardChanges };

    React.useEffect(() => {
        toggleModal?.(MODAL_ACTIONS.CONFIRM_ACTION, {
            hideClose: true,
            confirmButtonText: "popUp.confirm.gotit",
            confirmButtonColor: "btn-default",
            enableSaveDiscard: enableSaveDiscard,
            isHandleMultipleActions: false,
            moreContent: (
                <SaveDiscardMessage translate={translate}
                                    iframeHasUnsavedChanges={iframeHasUnsavedChanges}/>
            ),
            handleAction: () => {
                toggleModal(null);
                callbacksRef.current.remain?.();
            },
            saveCallback: () => callbacksRef.current.saveChanges?.(),
            discardCallback: () => callbacksRef.current.discardChanges?.(),
            closeCallback: () => callbacksRef.current.remain?.(),
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- open once on mount
    }, []);

    return null;
};

class TaskDetails extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            renderEditorInPortal: window.localStorage.getItem("@@grid/editor/portal") && window.localStorage.getItem("@@grid/editor/portal") !== "false",
            handledWarningEnabled: true,
            resizeHandlerHeight: "100%",
            enableModularViewResize: document.body.clientWidth > MIN_SCREEN_WIDTH_FOR_RESIZE,
            itemsVisible: {
                [WORKFLOW_DETAILS]: window.localStorage.getItem(`@@grid/workflow-details/visible`) !== "false",
                [DOCUMENT_DETAILS]: window.localStorage.getItem(`@@grid/document-details/visible`) !== "false",
                [DOCUMENT_PREVIEW]: window.localStorage.getItem(`@@grid/document-preview/visible`) !== "false",
                [COMMENTS]: window.localStorage.getItem(`@@grid/comments/visible`) !== "false",
                [EDITOR]: window.localStorage.getItem(`@@grid/editor/visible`) !== "false",
                [ACCOUNTING_GRID]: window.localStorage.getItem(`@@grid/accounting-grid/visible`) !== "false",
            },
        };

        this.timeOnPage = 0;
        this.resizeInstances = 0;
        this.logTimeOnPage = this.logTimeOnPage.bind(this);

        this.remain = this.remain.bind(this);
        this.togglePanelVisibility = this.togglePanelVisibility.bind(this);
        this.isEditorReadOnly = this.isEditorReadOnly.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.handleArrowKeys = this.handleArrowKeys.bind(this);
        this.handleNumericKeys = this.handleNumericKeys.bind(this);
        this.getPanelsVisibleForIntegration = this.getPanelsVisibleForIntegration.bind(this);
        this.computeLayoutClass = this.computeLayoutClass.bind(this);
        this.onRenderInPortalChange = this.onRenderInPortalChange.bind(this);
        this.saveEditorChanges = this.saveEditorChanges.bind(this);
        this.discardEditorChanges = this.discardEditorChanges.bind(this);
        this.sendMessageToEditor = this.sendMessageToEditor.bind(this);


        this.onResize = this.onResize.bind(this);
        this.onResizeStart = this.onResizeStart.bind(this);
        this.onResizeStop = this.onResizeStop.bind(this);
        this.handleWindowResize = this.handleWindowResize.bind(this);
        this.setRootStyle = this.setRootStyle.bind(this);
        this.maximizeAttachmentsPanel = this.maximizeAttachmentsPanel.bind(this);
        this.minimizeAttachmentsPanel = this.minimizeAttachmentsPanel.bind(this);
        this.isAttachmentPanelWidthDefault = this.isAttachmentPanelWidthDefault.bind(this);
        this.isAttachmentPanelMaxWidth = this.isAttachmentPanelMaxWidth.bind(this);
        this.pushResizeEventToPanels = this.pushResizeEventToPanels.bind(this);
        this.isHandled = this.isHandled.bind(this);
        this.getCommentsCount = this.getCommentsCount.bind(this);
        this.saveChanges = this.saveChanges.bind(this);
        this.discardChanges = this.discardChanges.bind(this);
        this.getEnableSaveDiscard = this.getEnableSaveDiscard.bind(this);
        this.blockNavigation = this.blockNavigation.bind(this);
        this.getAttachmentsPanel = this.getAttachmentsPanel.bind(this);
        this.setDocumentPreviewTitle = this.setDocumentPreviewTitle.bind(this);
        this.setEditorTitle = this.setEditorTitle.bind(this);
        this.readOnlyComments = this.readOnlyComments.bind(this);

        this.resizeHandler = React.createRef();
        this.workflowDetails = React.createRef();
        this.grid = React.createRef();
        this.editorPanelRef = React.createRef();
        this.attachmentsPanelRef = React.createRef();
        this.taskDetailsRef = React.createRef();
    }

    async componentDidMount() {
        const attachmentWidth = document.body.clientWidth < MIN_SCREEN_WIDTH_FOR_RESIZE ? this.grid.current?.clientWidth - 32 : this.grid.current?.clientWidth * 0.5 - 48;
        this.timeOnPage = Date.now();
        this.resizeInstances = 0;
        this.setState({
            handledWarningEnabled: true,
            resizeHandlerHeight: this.grid.current?.clientHeight,
            width: parseInt(window.localStorage.getItem(`@@grid/attachments-width`)) || attachmentWidth,
        }, () => {
            if (this.state.enableModularViewResize) {
                this.handleWindowResize();
            }
        });
        //handle shortcut keys
        window.addEventListener("keydown", this.handleKeyPress);
        window.addEventListener("resize", this.handleWindowResize);

        if (this.refs.details) {
            this.setState({
                panelHeight: this.refs.details.getBoundingClientRect().height,
            });
        }

        let shouldEnforceDialog = this.props.taskDetails.skipRestart && this.props.taskDetails.reapproveType === CONFIRMATION;
        this.props.approveMultipleShortcutKey(shouldEnforceDialog);
        this.props.changeTryToLoopTasksFlag(true);
        this.props.documentPreviewStatusChanged(DOCUMENT_PREVIEW_STATUS.AVAILABLE);
        this.setDocumentPreviewTitle();
        this.setEditorTitle();
        if (this.taskDetailsRef.current) {
            this.taskDetailsRef.current.focus();
        }

    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.loadingStatus !== prevProps.loadingStatus && this.props.loadingStatus === LOADING_STATUS.DONE) {
            let shouldEnforceDialog = this.props.taskDetails.skipRestart && this.props.docEditedFlag && this.props.taskDetails.reapproveType === CONFIRMATION;
            this.props.approveMultipleShortcutKey(shouldEnforceDialog);
            if (!this.getPanelsVisibleForIntegration()[DOCUMENT_PREVIEW]) {
                this.props.documentPreviewStatusChanged(DOCUMENT_PREVIEW_STATUS.UNAVAILABLE);
            }
        }

        if (this.props.params.taskId !== prevProps.params.taskId) {
            this.props.documentPreviewStatusChanged(DOCUMENT_PREVIEW_STATUS.AVAILABLE);
            this.timeOnPage = Date.now();
            this.resizeInstances = 0;
            this.setState({
                handledWarningEnabled: true,
            });
            this.setDocumentPreviewTitle();
            this.setEditorTitle();
        }

        // if (this.props.taskActionsRunning !== prevProps.taskActionsRunning && this.props.taskActionsRunning && this.props.commentsHaveUnsavedChanges) {
        //     this.props.routerBlocker?.unblockNavigation();
        // }

        if (this.props.iframeHasUnsavedChanges !== prevProps.iframeHasUnsavedChanges) {
            this.blockNavigation();
        }
    }

    componentWillUnmount() {
        this.props.taskDetailsClosing();
        snowplowTrackEvent({
            category: "task_details",
            action: "resize",
            label: "resize_with_drag",
            value: this.resizeInstances,
        }, this.props.userConfiguration);
        window.removeEventListener("keydown", this.handleKeyPress);
        if (this.state.enableModularViewResize)
            window.removeEventListener("resize", this.handleWindowResize);
        this.props.documentPreviewStatusChanged(DOCUMENT_PREVIEW_STATUS.WAITING);
        if (this.props.isEditorDetached) {
            this.props.editorReattach();
        }
    }

    logTimeOnPage() {
        if (this.props.taskActionsRunning && (this.props.actionParams.type === TASK_ACTIONS.APPROVE || this.props.actionParams.type === TASK_ACTIONS.REJECT)) {
            snowplowTrackEvent({
                category: "task_details",
                action: "task_details",
                label: "task_details_time_on_page",
                value: (Date.now() - this.timeOnPage) / 1000,
            }, this.props.userConfiguration);
        }
    }

    remain() {
        this.props.routerBlocker.blocker?.reset();
        this.setState({
            confirmNavigation: false,
        });
    }

    togglePanelVisibility(panelId) {
        this.setState({
            itemsVisible: {
                ...this.state.itemsVisible,
                [panelId]: !this.state.itemsVisible[panelId],
            },
        }, () => {
            Object.keys(this.state.itemsVisible)
                .forEach((key) => window.localStorage.setItem(`@@grid/${key}/visible`, this.state.itemsVisible[key]));

            if (!this.state.itemsVisible[COMMENTS] && !this.state.itemsVisible[WORKFLOW_DETAILS] && !this.state.itemsVisible[DOCUMENT_DETAILS]) {
                eventBus.dispatch("@@grid/refreshGridLayout");
                this.setState({
                    resizeHandlerHeight: this.grid.current?.clientHeight,
                });
            }
            eventBus.dispatch("@@grid/refreshAttachmentsPanelLayout");

            snowplowTrackEvent({
                category: "task_details",
                action: "show_hide_module",
                label: "toggle_module_" + panelId,
                value: this.state.itemsVisible[panelId],
            }, this.props.userConfiguration);
        });
    }

    isEditorReadOnly() {
        return this.props.type === DETAILS_VIEW_TYPE.HISTORY_TASK
            || this.props.type === DETAILS_VIEW_TYPE.PROCESS
            || (this.props.type === DETAILS_VIEW_TYPE.DOCUMENT && this.props.activeCounter !== DOCUMENT_OVERVIEW_STATUS.BLOCKED);
    }

    handleKeyPress(event) {
        event.stopPropagation();
        if (!canDo(event)) return;

        const numberOfAttachments = this.props.attachments?.length || 0;

        if (event.key >= '1' && event.key <= '9') {
            event.preventDefault();
            this.handleNumericKeys(event.key, numberOfAttachments);
        } else if (event.key === "e" || event.key === "E" || event.key === "q" || event.key === "Q") {
            event.preventDefault();
            this.handleArrowKeys(event.key, numberOfAttachments);
        } else {
            keyPressHandler(event, this.props.taskAction, [this.props.params.taskId], this.props.activeActions, this.props.routerBlocker.history);
        }
    }

    handleArrowKeys(key, numberOfAttachments) {
        if (numberOfAttachments > 0) {
            let direction = 0;
            if (key === "E" || key === "e") {
                direction = 1;
            } else if (key === "Q" || key === "q") {
                direction = -1;
            }
            const currentIndex = this.props.selectedDocument?.index || 0;
            const newIndex = currentIndex + direction;

            if (newIndex >= 0 && newIndex < numberOfAttachments) {
                this.props.selectedDocumentChanged(newIndex);
            }
        }
    }

    handleNumericKeys(key, numberOfAttachments) {
        const computedIndex = parseInt(key, 10) - 1;
        if (computedIndex >= 0 && computedIndex < numberOfAttachments) {
            this.props.selectedDocumentChanged(computedIndex);
        }
    }

    getPanelsVisibleForIntegration() {
        const applicationName = this.props.task.externalApplicationName || this.props.task.applicationTypeName || "";
        const docType = DOCUMENT_TYPE.asString(this.props.task.documentType);
        const integrationsForDocType = PANELS_BY_DOCTYPE_AND_INTEGRATION[docType];
        return integrationsForDocType ? (integrationsForDocType[applicationName] || PANELS_BY_DOCTYPE_AND_INTEGRATION.DEFAULT)
            : PANELS_BY_DOCTYPE_AND_INTEGRATION.DEFAULT;
    }

    computeLayoutClass(panelsVisible, accountingGridVisible) {
        let result = "grid";
        result += panelsVisible[WORKFLOW_DETAILS] ? "_workflow" : "";
        result += panelsVisible[DOCUMENT_DETAILS] ? "_data" : "";
        result += panelsVisible[DOCUMENT_PREVIEW] ? "_preview" : "";
        result += panelsVisible[COMMENTS] ? "_comments" : "";
        const editorVisibleInline = !this.props.isEditorDetached && (this.props.taskDetails.externalEditorAvailable || accountingGridVisible);
        result += editorVisibleInline ? ((this.state.renderEditorInPortal ? " editor-small" : " editor-large")) : "";

        return result;
    }

    onRenderInPortalChange(value) {
        this.setState({
                renderEditorInPortal: value,
            },
            () => {
                this.pushResizeEventToPanels();
                window.localStorage.setItem("@@grid/editor/portal", value);
                this.setState({
                    resizeHandlerHeight: this.grid.current?.clientHeight,
                });
            });
    };

    onResize = (event, {node, size, handle}) => {
        let attachmentsPanelWidth = size.width || this.resizeHandler.current?.clientWidth;
        let gridWidth = this.grid.current?.clientWidth - (2 * SPACE_BETWEEN_PANELS);
        let otherWidth = gridWidth - attachmentsPanelWidth - SPACE_BETWEEN_PANELS;
        if (otherWidth > LEFT_SIDE_MIN_WIDTH) {
            this.setState({width: attachmentsPanelWidth});
            this.setRootStyle(otherWidth, attachmentsPanelWidth);
        }
    };

    onResizeStop() {
        window.localStorage.setItem(`@@grid/attachments-width`, this.state.width);
        this.editorPanelRef?.current?.classList.remove("no-pointer-events");
        this.attachmentsPanelRef?.current?.classList.remove("no-pointer-events");
        this.resizeInstances = this.resizeInstances + 1;
        this.pushResizeEventToPanels();
    }

    onResizeStart() {
        this.editorPanelRef?.current?.classList.add("no-pointer-events");
        this.attachmentsPanelRef?.current?.classList.add("no-pointer-events");
    }

    handleWindowResize() {
        if (document.body.clientWidth < MIN_SCREEN_WIDTH_FOR_RESIZE) {
            this.setState({enableModularViewResize: false});
            return;
        }

        let attachmentPanelWidth = parseInt(window.localStorage.getItem(`@@grid/attachments-width`)) || this.resizeHandler.current?.clientWidth;
        let gridWidth = this.grid.current?.clientWidth;
        let otherWidth = gridWidth - attachmentPanelWidth - (SPACE_BETWEEN_PANELS * 2);

        if (otherWidth < LEFT_SIDE_MIN_WIDTH) {
            otherWidth = LEFT_SIDE_MIN_WIDTH;
            attachmentPanelWidth = gridWidth - otherWidth - (SPACE_BETWEEN_PANELS * 2);
        } else {
            attachmentPanelWidth = gridWidth / 2 - (SPACE_BETWEEN_PANELS * 2);
            otherWidth = gridWidth / 2 - SPACE_BETWEEN_PANELS;
        }

        this.setState({
            width: attachmentPanelWidth,
            enableModularViewResize: true
        });
        this.setRootStyle(otherWidth, attachmentPanelWidth);
        this.pushResizeEventToPanels();
    }

    setRootStyle(leftPanelWidth, rightPanelWidth) {
        const root = document.documentElement;
        root?.style.setProperty(
            "--columns_2_width_50_Template", leftPanelWidth + "px " + rightPanelWidth + "px",
        );
        root?.style.setProperty(
            "--columns_3_width_46_Template", leftPanelWidth / 2 + "px " + leftPanelWidth / 2 + "px " + rightPanelWidth + "px",
        );
    }

    maximizeAttachmentsPanel() {
        let leftSideWidth = LEFT_SIDE_MIN_WIDTH;
        const gridWidth = this.grid.current?.clientWidth - (3 * SPACE_BETWEEN_PANELS);
        const attachmentPanelWidth = gridWidth - leftSideWidth;
        this.setState({width: attachmentPanelWidth}, () => {
            this.pushResizeEventToPanels();
        });
        window.localStorage.setItem(`@@grid/attachments-width`, attachmentPanelWidth);
        this.setRootStyle(leftSideWidth, attachmentPanelWidth);
    }

    minimizeAttachmentsPanel() {
        if (!this.isAttachmentPanelWidthDefault()) {
            const gridWidth = this.grid.current?.clientWidth - (3 * SPACE_BETWEEN_PANELS);
            let attachmentPanelWidth = gridWidth * 0.5;
            const leftSideWidth = gridWidth - attachmentPanelWidth;
            this.setState({width: attachmentPanelWidth}, () => {
                this.pushResizeEventToPanels();
            });
            window.localStorage.setItem(`@@grid/attachments-width`, attachmentPanelWidth);
            this.setRootStyle(leftSideWidth, attachmentPanelWidth);
        }
    }

    isAttachmentPanelWidthDefault() {
        const gridTotalWidth = this.grid.current?.clientWidth - 10;
        const defaultAttPanelWidth = gridTotalWidth * 0.5;
        const attPanelWidth = this.resizeHandler.current?.clientWidth;

        return attPanelWidth >= defaultAttPanelWidth - 50 && attPanelWidth <= defaultAttPanelWidth + 50;
    }

    isAttachmentPanelMaxWidth() {
        const gridTotalWidth = this.grid.current?.clientWidth - 10;
        const attPanelWidth = this.resizeHandler.current?.clientWidth;
        const leftPanelWidth = gridTotalWidth - attPanelWidth;

        return leftPanelWidth >= LEFT_SIDE_MIN_WIDTH - 50 && leftPanelWidth <= LEFT_SIDE_MIN_WIDTH + 50;
    }

    pushResizeEventToPanels() {
        eventBus.dispatch("@@grid/refreshGridLayout");
        eventBus.dispatch("@@grid/refreshAttachmentsPanelLayout");
    }

    sendMessageToEditor(message) {
        snowplowTrackEvent({
            category: "task_details",
            action: "forgot_to_save_changes",
            label: "forgot_to_save_changes_in_editor",
            value: message.command,
        }, this.props.userConfiguration);

        const iframeElement = document.getElementById("Document-Editor-Iframe");
        const target = new URL(iframeElement?.src).origin;
        iframeElement?.contentWindow.postMessage(message, target);
    }

    saveEditorChanges() {
        const message = {
            command: "saveChanges",
        };
        this.sendMessageToEditor(message);
    }

    discardEditorChanges() {
        const message = {
            command: "discardChanges",
        };
        this.sendMessageToEditor(message);
    }

    getEnableSaveDiscard() {
        return this.props.iframeHasUnsavedChanges && this.props.iframeVBNXTSaveDiscardFlag;
    }

    saveChanges() {
        if (this.props.iframeHasUnsavedChanges) {
            this.saveEditorChanges();
        }
    }

    discardChanges() {
        if (this.props.iframeHasUnsavedChanges) {
            this.discardEditorChanges();
        }
    }

    blockNavigation() {
        this.props.routerBlocker?.shouldBlockNavigation(this.props.iframeHasUnsavedChanges);
    }

    isHandled() {
        const currentStatus = DETAILS_STATUS[this.props.workflowData?.status];
        return this.props.allowActionlessComments &&
            currentStatus !== DETAILS_STATUS.ACTIVE &&
            currentStatus !== DETAILS_STATUS.BLOCKED;
    }

    readOnlyComments() {
        return (this.props.allowActionlessComments ? this.isHandled() : this.props.isHistory || this.props.isHandled) ||
            (this.props.isDocument && !this.props.canAddDocumentComments) ||
            (this.props.isHistory && !this.props.canAddProcessComments);

    }

    getCommentsCount() {
        return this.props.allowActionlessComments ? this.props.commentsCount : (this.props.task.numberOfComments || this.props.taskDetails.numberOfComments);
    }

    getAttachmentsPanel() {
        return (
            <div className={"grid-panel-wrapper blue attachments-panel"}
                 ref={this.resizeHandler}>
                <div className={"attachments-panel__grid-panel grid-panel"}>
                    <PanelErrorBoundary panel="attachments">
                    {this.state.enableModularViewResize ?

                        <ResizableBox
                            width={this.state.width}
                            style={{height: "100%"}}
                            maxConstraints={[this.grid.current?.clientWidth - LEFT_SIDE_MIN_WIDTH, LEFT_SIDE_MIN_WIDTH]}
                            minConstraints={[LEFT_SIDE_MIN_WIDTH, LEFT_SIDE_MIN_WIDTH]}
                            resizeHandles={["w"]}
                            handle={<MyHandle translate={this.props.translate}
                                              height={this.grid.current?.clientHeight}/>}
                            draggableOpts={{grid: [25, 25]}}
                            onResize={this.onResize}
                            onResizeStop={this.onResizeStop}
                            onResizeStart={this.onResizeStart}>
                            <div ref={this.attachmentsPanelRef} className={"h-100 grid-panel"}>
                                <AttachmentsPanel attachments={this.props.attachments}
                                                  width={this.state.width}
                                                  loadingStatus={this.props.loadingStatus}
                                                  taskDetails={this.props.taskDetails}
                                                  translate={this.props.translate}
                                                  type={this.props.type}
                                                  rerender={this.state.reRenderAttachments}
                                                  maximizePanel={this.maximizeAttachmentsPanel}
                                                  minimizePanel={this.minimizeAttachmentsPanel}
                                                  isAttachmentPanelWidthDefault={this.isAttachmentPanelWidthDefault()}
                                                  isAttachmentPanelMaxWidth={this.isAttachmentPanelMaxWidth()}
                                                  isFullWidth={this.state.itemsVisible[COMMENTS] || this.state.itemsVisible[WORKFLOW_DETAILS] || this.state.itemsVisible[DOCUMENT_DETAILS]}
                                />
                            </div>
                        </ResizableBox> :
                        <AttachmentsPanel attachments={this.props.attachments}
                                          loadingStatus={this.props.loadingStatus}
                                          taskDetails={this.props.taskDetails}
                                          translate={this.props.translate}
                                          type={this.props.type}
                                          isFullWidth={this.state.itemsVisible[COMMENTS] || this.state.itemsVisible[WORKFLOW_DETAILS] || this.state.itemsVisible[DOCUMENT_DETAILS]}
                        />
                    }
                    </PanelErrorBoundary>
                </div>
            </div>
        );
    }

    setDocumentPreviewTitle() {
        let documentPreviewTitle = this.props.translate("documentType." + DOCUMENT_TYPE.asString(this.props.task.documentType)) + " - " + this.props.navigation.shortTitle + " → " + this.props.navigation.companyName;
        this.props.documentPreviewTitleChanged(documentPreviewTitle);
    }

    setEditorTitle() {
        let editorTitle = this.props.translate("taskDetail.externalEditor") + " - " + this.props.navigation.shortTitle + " → " + this.props.navigation.companyName;
        this.props.editorTitleChanged(editorTitle);
    }

    render() {

        const editorReadOnly = this.isEditorReadOnly();
        const areActionCommentsVisible = this.props.allowActionlessComments ? true : !this.props.isDocument;

        const editorOnly = this.state.itemsVisible[EDITOR] && ![WORKFLOW_DETAILS, DOCUMENT_DETAILS, DOCUMENT_PREVIEW, COMMENTS].some((id) => this.state.itemsVisible[id]);
        const panelsVisibleForIntegration = this.getPanelsVisibleForIntegration();

        const panelsVisible = {
            [WORKFLOW_DETAILS]: this.state.itemsVisible[WORKFLOW_DETAILS] && panelsVisibleForIntegration[WORKFLOW_DETAILS],
            [DOCUMENT_DETAILS]: this.state.itemsVisible[DOCUMENT_DETAILS] && panelsVisibleForIntegration[DOCUMENT_DETAILS],
            [DOCUMENT_PREVIEW]: this.props.isPreviewDetached ? false : this.state.itemsVisible[DOCUMENT_PREVIEW] && panelsVisibleForIntegration[DOCUMENT_PREVIEW],
            [COMMENTS]: this.state.itemsVisible[COMMENTS] && panelsVisibleForIntegration[COMMENTS] && areActionCommentsVisible,
            [EDITOR]: this.state.itemsVisible[EDITOR] && panelsVisibleForIntegration[EDITOR],
            [ACCOUNTING_GRID]: this.state.itemsVisible[ACCOUNTING_GRID] && panelsVisibleForIntegration[ACCOUNTING_GRID],
        };

        const accountingGridVisible = this.props.task?.hasAccountingGrid || this.props.task?.allowGridEdit || (this.props.taskDetails && this.props.taskDetails.allowGridEdit);
        const containerClass = this.computeLayoutClass(panelsVisible, accountingGridVisible);
        this.logTimeOnPage();


        return (
            <div>
                <DocumentPreviewWindow onKeyPress={this.handleKeyPress} translate={this.props.translate}/>
                <DocumentEditorWindow {...this.props}
                                      onKeyPress={this.handleKeyPress}
                                      editorReadOnly={editorReadOnly}
                                      onRenderInPortalChange={this.onRenderInPortalChange}/>
                <div id="task-details-wrapper" className={`${editorOnly ? "editor-only" : ""}`} tabIndex={-1}
                     ref={this.taskDetailsRef}>
                    <AsyncTaskActionExecutorTask
                        translate={this.props.translate}
                        type={this.props.type}
                        taskDetails={this.props.taskDetails}
                        navigateBetweenTasks={this.props.navigateBetweenTasks}
                        reloadTasks={() => this.props.loadTasks()}
                    />

                    {(this.state.confirmNavigation || this.props.routerBlocker?.isNavigationBlocked()) &&
                        <NavigationConfirmTrigger
                            translate={this.props.translate}
                            iframeHasUnsavedChanges={this.props.iframeHasUnsavedChanges}
                            enableSaveDiscard={this.getEnableSaveDiscard()}
                            remain={this.remain}
                            saveChanges={this.saveChanges}
                            discardChanges={this.discardChanges}
                        />
                    }

                    {this.props.task.isHandled && this.state.handledWarningEnabled &&
                        <HandledTaskTrigger closeCallback={() => {
                                         this.setState({handledWarningEnabled: false});
                                     }}/>
                    }

                    <TaskDetailsSubnavbar editorReadOnly={editorReadOnly} {...this.props}
                                          togglePanelVisibility={this.togglePanelVisibility}
                                          panelVisibility={panelsVisible}/>

                    <div className="grid-layout-with-sidebar ">
                        <div className={`grid-layout-wrapper`}>
                            <div className="grid-panel-wrapper">

                                <img src={MouseDown} className={"more-items-img border-0 d-none"}
                                     alt={"scroll down"}/>

                                <div ref={this.grid}
                                     className={containerClass + " grid-base "} data-cy="taskDetail.gridBase">
                                    {this.getAttachmentsPanel()}

                                    {this.props.taskDetails.externalEditorAvailable && !this.props.isEditorDetached &&
                                        <div className={"editor" + (this.state.renderEditorInPortal ? " small" : "")}
                                             ref={this.editorPanelRef}>
                                            <PanelErrorBoundary panel="documentEditor">
                                                <DocumentEditorPanel {...this.props}
                                                                     renderInPortal={this.state.renderEditorInPortal}
                                                                     editorReadOnly={this.isEditorReadOnly()}
                                                                     onRenderInPortalChange={this.onRenderInPortalChange}/>
                                            </PanelErrorBoundary>
                                        </div>
                                    }


                                    <div className="doc-data">
                                        <div className={"grid-panel"}>
                                            <PanelErrorBoundary panel="documentData">
                                                <DocumentData taskId={this.props.params.taskId}
                                                              documentType={this.props.task.documentType}
                                                              translate={this.props.translate}
                                                              readOnly={this.props.readOnly}
                                                              isDocument={this.props.isDocument}/>
                                            </PanelErrorBoundary>
                                        </div>
                                    </div>

                                    <div className="workflow-details">
<div className={launchDarkly.userClient?.variation(NEW_WORKFLOW_DETAILS_FLAG, false) ? undefined : "grid-panel"}
     ref={this.workflowDetails}>
                                            <PanelErrorBoundary panel="workflowDetails">
                                                {launchDarkly.userClient?.variation(NEW_WORKFLOW_DETAILS_FLAG, false) ?
                                                    <NewWorkflowDetailsPanel taskId={this.props.params.taskId}
                                                                             isDocument={this.props.isDocument}
                                                                             taskDetails={this.props.taskDetails}
                                                                             documentDueDate={this.props.task?.documentDueDate}
                                                                             taskDueDate={this.props.task?.dueDate}/> :
                                                    <WorkflowDetailsPanel taskId={this.props.params.taskId}
                                                                          isDocument={this.props.isDocument}/>}
                                            </PanelErrorBoundary>
                                        </div>
                                    </div>

                                    <div className="comments">
                                        <div className={"grid-panel"}>
                                            <PanelErrorBoundary panel="comments">
                                            <DraftAndCommentsComponent taskId={this.props.params.taskId}
                                                                       uid={this.props.task.uid}
                                                                       documentUid={this.props.task.documentUid ? this.props.task.documentUid : this.props.task.uidDocument}
                                                                       readOnly={this.readOnlyComments()}
                                                                       isDocument={this.props.isDocument}
                                                                       initialCommentsCount={this.props.task.numberOfComments || this.props.taskDetails.numberOfComments}
                                                                       taskDetailsType={this.props.type}
                                                                       addCommentHandler={this.props.addCommentHandler}
                                                                       getCommentsHandler={this.props.getCommentsHandler}
                                                                       allowExtraComments={this.props.isDocument || this.props.allowActionlessComments}
                                            />
                                            </PanelErrorBoundary>
                                        </div>
                                    </div>

                                    {accountingGridVisible && !this.props.isEditorDetached &&
                                        <div className={"accounting-grid-panel"}>
                                            <PanelErrorBoundary panel="accountingGrid">
                                                <AccountingGridPanel {...this.props}
                                                                     renderInPortal={this.state.renderEditorInPortal}
                                                                     onRenderInPortalChange={this.onRenderInPortalChange}/>
                                            </PanelErrorBoundary>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <div role={"complementary"} aria-label={"modules-actions"}>
                            <TaskSidebar togglePanelVisibility={this.togglePanelVisibility}
                                         documentData={this.props.documentData}
                                         panelVisibility={panelsVisible}
                                         panelAvailability={panelsVisibleForIntegration}
                                         translate={this.props.translate}
                                         isCommentsVisible={areActionCommentsVisible}
                                         commentsCount={this.getCommentsCount()}/>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}

const withTranslations = translate(TaskDetails);

const
    connected = connect((store) => ({
        workflowData: reduxSelectors.getTaskWorkflowDetails(store),
        userLanguage: reduxSelectors.getLanguage(store),
        documentData: reduxSelectors.getTaskDocumentData(store),
        taskActionsRunning: reduxSelectors.areTaskActionsRunning(store),
        actionParams: reduxSelectors.getActionParameters(store),
        userConfiguration: reduxSelectors.getUsersData(store),
        commentsCount: reduxSelectors.getTaskDraftCommentsCount(store),
        iframeHasUnsavedChanges: reduxSelectors.getIframeHasUnsavedChanges(store),
        iframeVBNXTSaveDiscardFlag: reduxSelectors.getVBNXTSaveDiscardFlag(store),
        isPreviewDetached: reduxSelectors.isDocumentPreviewDetached(store),
        isEditorDetached: reduxSelectors.isEditorDetached(store),
        canAddDocumentComments: reduxSelectors.canAddDocumentComments(store),
        canAddProcessComments: reduxSelectors.canAddProcessComments(store),
        selectedDocument: reduxSelectors.getSelectedDocument(store),
    }), {
        loadTasks,
        approveMultipleShortcutKey,
        changeTryToLoopTasksFlag,
        documentPreviewTitleChanged,
        documentPreviewStatusChanged,
        editorTitleChanged,
        editorReattach,
        taskDetailsClosing,
        selectedDocumentChanged
    })(withTranslations);

export default connected;


TaskDetails.propTypes = {
    attachments: PropTypes.array,
    selectedDocument: PropTypes.object,
    selectedDocumentChanged: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
}

// @ts-ignore
class MyHandleComponent extends React.Component {
    render() {
        const {handleAxis, innerRef, ...props} = this.props;
        return <div ref={innerRef} className={`handle-resize-${handleAxis}`} {...props}
                    style={{height: this.props.height - 10 + "px"}}>
            <div className={"resize-handle-blue"} data-tip="resize-handle-tooltip" data-for={SHARED_TOOLTIP_ID}/>
            <Tooltip id="resize-handle-tooltip" content={() => props.translate("taskDetail.dragToResize")}/>
        </div>;
    }
}

const MyHandle = React.forwardRef((props, ref) => <MyHandleComponent innerRef={ref} {...props} />);